"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
// Returns true if argument is empty, null, undefined or false
// but 0 will return true
const isNada = ramda_1.curry(function (x) {
    return ramda_1.isEmpty(x) || ramda_1.isNil(x) || x === false;
});
exports.default = isNada;
